import { RagAuthGate } from "./components/RagAuthGate.js";

/** RAG module layout — pages render inside DashboardLayout outlet. */
export function RagLayout() {
  return <RagAuthGate />;
}
